import { useTranslation } from 'react-i18next';
export const useCharacterClassTypes = () => {
    const { t } = useTranslation();
    return [
        { value: 'artificer', label: t('character.classes.artificer') },
        { value: 'bard', label: t('character.classes.bard') },
        { value: 'barbarian', label: t('character.classes.barbarian') },
        { value: 'druid', label: t('character.classes.druid') },
        { value: 'fighter', label: t('character.classes.fighter') },
        { value: 'rogue', label: t('character.classes.rogue') },
        { value: 'ranger', label: t('character.classes.ranger') },
        { value: 'cleric', label: t('character.classes.cleric') },
        { value: 'paladin', label: t('character.classes.paladin') },
        { value: 'monk', label: t('character.classes.monk') },
        { value: 'sorcerer', label: t('character.classes.sorcerer') },
        { value: 'wizard', label: t('character.classes.wizard') },
        { value: 'warlock', label: t('character.classes.warlock') },
    ];
};
